var map = {
	"./alluvione-compact.svg": 92796,
	"./frane-compact.svg": 55494,
	"./fulminazione-compact.svg": 62873,
	"./grandine-compact.svg": 49915,
	"./pioggia-compact.svg": 21297,
	"./resilienza-compact.svg": 39076,
	"./sostenibilita-compact.svg": 21063,
	"./sostenibilità-compact.svg": 77422,
	"./temperatura-compact.svg": 40243,
	"./vento-compact.svg": 31207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26456;